import axios from 'axios';

// Configuration des URLs - Production: api.saucistats.com | Développement: localhost:4000
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Generic CRUD functions
const createCRUDService = (endpoint) => ({
  getAll: () => api.get(`/${endpoint}`),
  getById: (id) => api.get(`/${endpoint}/${id}`),
  create: (data) => api.post(`/${endpoint}`, data),
  update: (id, data) => api.put(`/${endpoint}/${id}`, data),
  delete: (id) => api.delete(`/${endpoint}/${id}`),
});

export const smasheursService = {
  ...createCRUDService('smasheurs'),
  getWithTournois: (id) => api.get(`/smasheurs/${id}/tournois`),
};

export const tournoisService = createCRUDService('tournois');
export const classementsService = createCRUDService('classements');
export const tropheesService = createCRUDService('trophees');
export const anecdotesService = createCRUDService('anecdotes');

// Pins service with image upload support
export const pinsService = {
  getAll: () => api.get('/pins'),
  getById: (id) => api.get(`/pins/${id}`),
  create: (formData) => api.post('/pins', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  update: (id, formData) => api.put(`/pins/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  delete: (id) => api.delete(`/pins/${id}`),
};

export const statsService = {
  getStats: () => api.get('/stats'),
};

export const syncService = {
  syncTournois: () => api.post('/sync/tournois'),
  syncPersonnages: () => api.post('/sync/personnages'),
};

export default api;